import $ from 'jquery';
import OverlayService from '../../Services/OverlayService';

import widgetFactory from '../widgetFactory';

const widgetName = 'slidingSidebar';

const widget = widgetFactory(widgetName, {
  options: {},

  _create: function () {
    this._super(widgetName);
    this.enable();
    this.overlay = new OverlayService({ invisibleBackground: false, loadingCursor: false });
  },

  _showToggler: function () {
    if (!this.elements.$toggler) {
      this.elements.$toggler = $('<div>').addClass('slidingSidebar__toggler');

      $('<i>').addClass('icon-plus  slidingSidebar__togglerOpen').appendTo(this.elements.$toggler);

      $('<i>')
        .addClass('icon-minus  slidingSidebar__togglerClose')
        .appendTo(this.elements.$toggler);

      this.elements.$toggler.prependTo(this.element).on(
        'tap',
        function () {
          this.toggle();
        }.bind(this)
      );
    }

    this.elements.$toggler.show();
  },

  _hideToggler: function () {
    this.elements.$toggler.hide();
  },

  _showContainer: function () {
    if (!this.elements.$barContainer) {
      this.elements.$barContainer = $('<div>')
        .addClass('slidingSidebar')
        .width(this.element.width() * 2)
        .appendTo($('body'));
    }
    this.elements.$barContainer.show();
  },

  _hideContainer: function () {
    this.elements.$barContainer.hide();
  },

  _moveContent: function () {
    this.elements.$placeholder = $('<span>').insertAfter(this.element);

    this.element.addClass('slidingSidebar__content').appendTo(this.elements.$barContainer);
  },

  _restoreContent: function () {
    this.element
      .width('')
      .removeClass('slidingSidebar__content')
      .insertBefore(this.elements.$placeholder);

    this.elements.$placeholder.remove();
  },

  enable: function () {
    if (this.isEnabled) {
      return;
    }
    this._showContainer();
    this._moveContent();
    this._showToggler();

    this.isEnabled = true;
  },

  disable: function () {
    if (!this.isEnabled) {
      return;
    }
    this._hideContainer();
    this._restoreContent();
    this._hideToggler();

    this.isEnabled = false;
  },

  open: function () {
    this.toggle(true);
  },

  close: function () {
    this.toggle(false);
  },

  toggle: function (state) {
    this.overlay.toggle(state);
    this.elements.$barContainer.toggleClass('is-opened', state);
  },
});

export default widget;
